<template>
  <li
    class="p-team-user-profile-list__item"
    :class="{'is-active': isActive}"
  >
    <div class="p-team-user-profile__title">名前</div>
    <div class="p-team-user-profile__text">{{name}}</div>
    <div class="p-team-user-profile__editor">
      <div
        class="c-input"
        :class="{'is-error': valid.name != ''}"
      >
        <input
          v-model="params.name"
          class="c-input__item"
          type="text"
          name="name"
          placeholder="名前を入力してください"
          @blur="onChangeName"
          @input="onChangeName"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.name != ''}"
        >
          <div class="c-error__text">{{ valid.name }}</div>
        </div>
      </div>
    </div>
    <div class="p-team-user-profile__switch">
      <div class="c-text">
        <a @click="onToggleNameClick">変更する</a>
      </div>
    </div>
    <div class="p-team-user-profile__btns">
      <a
        class="c-btn c-btn--gray u-w120 u-h30"
        @click="onCancelNameClick($event.target.value)"
      >
        <p class="c-btn__text">キャンセル</p>
      </a>
      <button
        :class="{'is-loading': isLoading}"
        class="c-btn c-btn--blue u-w120 u-h30"
        type="button"
        name="add_name"
        value="add-user"
        :disabled="isLoading || valid.name != ''"
        @click="onChangeNameClick($event)"
      >
        <p class="c-btn__text">保存する</p>
      </button>

    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </li>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    initialName: String,
  },
  data () {
    return {
      errorMessage: '',
      isActive: false,
      isError: false,
      isLoading: false,
      name: this.initialName,
      params: {
        name: this.initialName,
      },
      valid: {
        name: '',
      }
    }
  },
  methods: {
    onToggleNameClick: function() {
      this.isActive = !this.isActive;
    },

    onCancelNameClick: function(_event) {
      this.isActive = false;
    },

    onChangeName:  function() {
      if (!this.params.name || this.params.name == '') {
        this.valid.name = '名前を入力してください';
      } else {
        this.valid.name = '';
      }
    },

    onChangeNameClick: function(event) {
      event.preventDefault();
      this.isLoading = true;

      const data = {
        name: this.params.name,
      };

      axios.post('/api/team/update-name',data)
        .then(res => {
          if (this.handleResponse(res)){
            this.name = res.data.name;
            this.isActive = false;
          } else {
            this.isError = true;
            this.errorMessage = '名前の更新に失敗しました'
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = '名前の更新に失敗しました'
          setTimeout(() => { this.isLoading = false; }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },

}
</script>
